export default {"src":"/_next/static/media/AXP.ef6234c2.svg","height":18,"width":18};